import { useTranslation } from "../../../../../explorer/hooks/useTranslation";
import { Root } from "./AppContext.styles";


const AppContext = () => {
  const { t } = useTranslation();
  return <Root>{t("common.appcontext.serviceportal")}</Root>;
};

export default AppContext;
